<template>
    <gofix-card class="mb-0" title="Priority Matrix" fullContent  classHeader="mb-5 pl-23" classContent="pd-0">
        <gofix-default-table :settings="tableConfig"
                :table-items="tableItems"
                @new-item="openModalCreate"
                @load-items="getTableData"
                @row-click="openModalEdit"
                @delete-items="deleteItems"
                ref="gofixTable">
                <template slot="gofix_table:description" slot-scope="row">
                    {{ row.item.description || "--"}}
                </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.title" hide-footer :centered="true" v-model="modals.open"  refs="modal-Create">
            <b-form class="pb-20">
                <gofix-form-tree
                    label="Service Category"
                    :multiple="false"
                    :options="serviceCategories"
                    :load-options="loadOptionServices"
                    search-nested
                    v-model="modals.data.service_category_id"
                    :normalizer="normalizer">
                </gofix-form-tree>
                <gofix-form-dropdown
                    label="Fault Type"
                    vLabel="fault_name"
                    :filterable="true"
                    :multiple="modals.data.id ? false : true"
                    :required="true"
                    v-model="modals.data.fault_type"
                    :options="modals.options.fault_types">
                </gofix-form-dropdown>
                 <gofix-form-dropdown
                    label="Priority"
                    vLabel="priority"
                    :filterable="true"
                    :required="true"
                    v-model="modals.data.sla"
                    :options="modals.options.slas">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveItem" :loading="modals.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    import { mapGetters } from 'vuex';
    export default {
        name: 'sla-fault-type',
        components: {},
        props: {
            contract_id: {
                type: Number,
                default: null
            },
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['sla_priority_fault_type']));
            return {
                tableItems: [],
                tableConfig:{
                    name: 'client-contract-sla-priority-fault-type',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "fault_name",
                    sortDirection: "asc",
                },
                normalizer(node) {
                    if (node.isBatch)
                        return {
                            label: node.name,
                            children: node.children
                        };
                    return {
                        label: node.name,
                        children: undefined
                    }
                },
                modals: {
                    options: {
                        slas: [],
                        fault_types: []
                    },
                    title: 'Priority Matrix',
                    timer: null,
                    open: false,
                    loading: false,
                    prev_id: null,
                    data: {
                        id: 0,
                        service_category_id: null,
                        fault_type_id: null,
                        sla: null,
                        fault_type: null
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                serviceCategories: 'v2SlaController/serviceCategories'
            }),
        },
        created() {},
        watch: {
            contract_id: function(val) {
                this.getServices();
                this.reloadData();
            },
            "modals.data.service_category_id": function(val, old) {
                if(val) {
                    this.getSLA();
                    this.getFaultType(val);
                }

                if(this.modals.prev_id === this.modals.data.id) {
                    if(old && old != val) {
                        this.modals.data.sla = null;
                    }
                } else {
                    this.modals.prev_id = this.modals.data.id;
                }
            }
        },
        methods: {
            reloadData() {
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id.value = this.contract_id
                await this.$store.dispatch("v2SlaController/getSLAFaultType", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("v2SlaController/deleteSLAFaultType", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'fault_type'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            saveItem() {
                if(!this.modals.data.service_category_id) {
                    return this.$alertNotification("Category service is required", "danger");
                }

                if(!this.modals.data.sla) {
                    return this.$alertNotification("Priority is required", "danger");
                }

                if(!this.modals.data.fault_type) {
                    return this.$alertNotification("Fault Type Name is required", "danger");
                }

                if(this.modals.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                let api = 'createSLAFaultType';
                let keyMsg = 'adding';

                let request = {
                    id: this.modals.data.id,
                    sla_id: this.modals.data.sla && this.modals.data.sla.id ? this.modals.data.sla.id : 0,
                };

                if(!this.modals.data.id) {
                    if(this.modals.data.fault_type.length > 0) {
                        request.fault_type_id = this.modals.data.fault_type.map(item => item.id);
                    }
                } else {
                    request.fault_type_id = this.modals.data.fault_type.id;
                    api = "updateSLAFaultType";
                    keyMsg = "editing";
                }
                
                this.modals.timer = setTimeout(() => {
                    this.modals.loading = true;
                    this.$store.dispatch(`v2SlaController/${api}`, request)
                    .then(result => {
                        this.modals.open = false;
                        this.modals.loading = false;
                        this.reloadData();
                        this.$alertNotification(this.$notificationV2(keyMsg, 'fault_type'));
                    })
                    .catch(error => {
                        this.modals.loading = false;
                        if(error.response) {
                            if(error.response.data.error.message.error) {
                                return this.$alertNotification(error.response.data.error.message.error, "danger");
                            }
                            this.$alertNotification("Error", "danger");
                        }
                    })
                }, 300)
            },
            openModalCreate() {
                this.modals.title = 'Priority Matrix';
                this.modals.data = Object.assign(this.modals.data, {
                    id: 0,
                    service_category_id: null,
                    fault_type_id: null,
                    sla: null,
                    fault_type: null
                })
                this.modals.open = true
            },
            openModalEdit(item) {
                this.modals.title = 'Edit Fault Type';
                this.modals.data.id = item.id;
                this.modals.data.service_category_id = item.service_category_id;
                this.modals.data.fault_type_id = item.fault_type_id;
                this.modals.data.fault_type = {
                    id: item.fault_type_id,
                    fault_name: item.fault_name,
                }
                this.modals.data.sla = {
                    id: item.sla_id,
                    priority: item.priority,
                }
                this.modals.open = true
            },
            getSLA() {
                this.$store.dispatch("v2SlaController/getSlaList", {
                    limit:-1,
                    page: 1,
                    filter: {
                        service_category_id: this.modals.data.service_category_id
                    },
                }).then(response => {
                    this.modals.options.slas = response.items;
                });
            },
            getFaultType(id) {
                this.$store.dispatch("FaultTypeController/getItems", {
                    service_category_id: id
                })
                .then(response => {
                    this.modals.options.fault_types = response.items;
                })
                .catch(err => {
                    this.modals.options.fault_types = [];
                })
            },
            getServices() {
                this.$store.dispatch('v2SlaController/getServiceCategories', {
                    contractId: this.contract_id,
                    categoryId: 0
                }).then(response => {});
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("v2SlaController/getServiceCategories", {
                        contractId: this.contract_id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }

            }
        }
    }
</script>
